import React, { useState, useEffect } from "react";
import { Form, Layout, Table, Button, Tabs, Spin, Modal, Input } from "antd"
import { SendOutlined } from "@ant-design/icons"
import axios from "axios"
import SideNavBar from "../../Components/SideBar/Sidebar"
import Navbar from "../../Components/Support/Header"
// import './StatutoryReporting.css'
import "../../GlobalCss/SPF/StatutoryReporting.css"
import Cookies from "js-cookie"
import { ErrorMessage, SuccessMessage, WarnMessage } from "../../Utils/Utils"
const { Header, Content } = Layout
const { TabPane } = Tabs
const { TextArea } = Input

const ReportingTable = () => {
    const jwtToken = Cookies.get("jwt_token")
    const userLogin = Cookies.get("UserLogin")
    const [form] = Form.useForm()
    const [Statutorydata, getStatutoryData] = useState([])
    const [StatutoryWeedata, getStatutoryWeeData] = useState([])
    const [tableLoader, setTableLoader] = useState(false)
    const [selectedRowKeysBiWeekly, setSelectedRowKeysBiWeekly] = useState([])
    const [selectedRowKeysWeekly, setSelectedRowKeysWeekly] = useState([])
    const [Mailpopup, setMailpopup] = useState(false)
    const [selectedBiWeeklyRows, setSelectedBiWeeklyRows] = useState([])
    const [selectedWeeklyRows, setSelectedWeeklyRows] = useState([])
    const [fromAdd, setFromAdd] = useState('')
    const [fromName, setFromName] = useState('')
    const [subject, setSubject] = useState('')
    const [body, setBody] = useState([])
    const [toAdd, setToAdd] = useState([])
    const [ccAdd, setCCAdd] = useState([])
    const [loaderMail, setLoaderMail] = useState(false)
    const [error, setError] = useState('')

    useEffect(() => {
        GetStatuReportsData();
    }, [])

    useEffect(() => {
        const newSelectedWeeklyRows = StatutoryWeedata.filter(item =>
            selectedRowKeysWeekly.includes(item.FileNumber)
        );
        setSelectedWeeklyRows(newSelectedWeeklyRows)
    }, [selectedRowKeysWeekly, StatutoryWeedata])

    useEffect(() => {
        const newSelectedBiWeeklyRows = Statutorydata.filter(item =>
            selectedRowKeysBiWeekly.includes(item.FileNumber)
        );
        setSelectedBiWeeklyRows(newSelectedBiWeeklyRows)
    }, [selectedRowKeysBiWeekly, Statutorydata])

    const GetStatuReportsData = async () => {
        try {
            let url = `${process.env.REACT_APP_BASE_URL}StatutoryReport/NonExemptHrs`
            const config = {
                headers: {
                    "content-type": "application/json",
                    Authorization: `Bearer ${jwtToken}`,
                }
            }
            setTableLoader(true)
            const response = await axios.get(url, config)
            if (response.data.statusCode == 200) {
                const res = response.data.payload
                const data = JSON.parse(res)
                getStatutoryData(data.BiweeklyData)
                getStatutoryWeeData(data.WeeklyEmployeeData)
                setTableLoader(false)
            }
            else {
                setTableLoader(false)
            }
        }
        catch (error) {
            setTableLoader(false)
            ErrorMessage("Error while fetching the data.")
        }
    }
    const SendEmail = async () => {
        if (fromAdd.length === 0 || fromName.length === 0 || toAdd.length === 0 || ccAdd.length === 0 || subject.length === 0 || body.length === 0) {
            setError('*Please enter all fields')
            return;
        }
        if (!emailValidationRegex.test(fromAdd) || !emailValidationRegex.test(toAdd) || (ccAdd && !emailValidationRegex.test(ccAdd))) {
            setError('Please ensure all email addresses are valid.')
            return
        }
        setError('')
        try {
            let url = `${process.env.REACT_APP_BASE_URL}StatutoryReport/SendNonExemptMail`
            const config = {
                headers: {
                    "content-type": "application/json",
                    Authorization: `Bearer ${jwtToken}`,
                }
            }
            const data = {
                helpSupport: {
                    fromAddress: fromAdd,
                    fromName: fromName,
                    subject: subject,
                    body: body,
                    tos: [
                        toAdd
                    ],
                    ccs: [
                        ccAdd
                    ]
                },
                reportModel: {
                    biweeklyData: selectedBiWeeklyRows,
                    weeklyData: selectedWeeklyRows
                }
            }
            setLoaderMail(true)
            const response = await axios.post(url, data, config)
            if (response.status == 200) {
                SuccessMessage("Email sent successfully !!")
                setLoaderMail(false)
                setMailpopup(false)
                setError('')
                setFromAdd('')
                setFromName('')
                setCCAdd([])
                setToAdd([])
                setSubject('')
                setBody('')
            }
        }
        catch (error) {
            ErrorMessage("Unable to sent mail !")
            setLoaderMail(false)
            setMailpopup(false)
            setError('')
            setFromAdd('')
            setFromName('')
            setCCAdd([])
            setToAdd([])
            setSubject('')
            setBody('')
        }
    }

    const columns = [
        {
            title: 'File_No',
            dataIndex: 'FileNumber',
            key: 'File_No',
            width: 100,
            editable: true,
        },
        {
            title: 'Employee Name',
            dataIndex: 'EmployeeName',
            key: 'EmployeeName',
            width: 50,
            editable: true,
        },
        {
            title: 'Client',
            dataIndex: 'Client',
            key: 'Client',
            width: 50,
            editable: true,
        },
        {
            title: Statutorydata[0] ? Statutorydata[0].WeekendDates1 : 'Weekend Dates 1',
            children: [
                {
                    title: 'RT',
                    dataIndex: 'RegularTimeWeek1',
                    key: 'RegularTimeWeek1',
                },
                {
                    title: 'OT',
                    dataIndex: 'OvertimeWeek1',
                    key: 'OvertimeWeek1',
                },
                {
                    title: 'DT',
                    dataIndex: 'DoubletimeWeek1',
                    key: 'DoubletimeWeek1',
                },
            ],
        },
        {
            title: Statutorydata[0] ? Statutorydata[0].WeekendDates2 : 'Weekend Dates 2',
            dataIndex: 'WeekendDates2',
            children: [
                {
                    title: 'RT',
                    dataIndex: 'RegularTimeWeek2',
                    key: 'RegularTimeWeek2',
                },
                {
                    title: 'OT',
                    dataIndex: 'OvertimeWeek2',
                    key: 'OvertimeWeek2',
                },
                {
                    title: 'DT',
                    dataIndex: 'DoubletimeWeek2',
                    key: 'DoubletimeWeek2',
                },
            ],
        },
    ]

    const Weecolumns = [
        {
            title: 'File_No',
            dataIndex: 'FileNumber',
            key: 'File_No',
            width: 100,
            editable: true,
        },
        {
            title: 'Employee Name',
            dataIndex: 'EmployeeName',
            key: 'EmployeeName',
            width: 150,
            editable: true,
        },
        {
            title: 'Client',
            dataIndex: 'Client',
            key: 'Client',
            width: 50,
            editable: true,
        },
        {
            title: StatutoryWeedata[0] ? StatutoryWeedata[0].WeekendDates : 'Weekend Dates',
            children: [
                {
                    title: 'RT',
                    dataIndex: 'RegularTime',
                    key: 'RegularTime',
                    width: 70,
                },
                {
                    title: 'OT',
                    dataIndex: 'Overtime',
                    key: 'Overtime',
                    width: 70,
                },
                {
                    title: 'DT',
                    dataIndex: 'Doubletime',
                    key: 'Doubletime',
                    width: 70,
                },
            ],
        },
    ]

    const onSelectChangeBiWeekly = (newSelectedRowKeys) => {
        setSelectedRowKeysBiWeekly(newSelectedRowKeys)
    }

    const rowSelectionBiWeekly = {
        selectedRowKeys: selectedRowKeysBiWeekly,
        onChange: onSelectChangeBiWeekly,
    }

    // Selection for Weekly
    const onSelectChangeWeekly = (newSelectedRowKeys) => {
        setSelectedRowKeysWeekly(newSelectedRowKeys)
    }

    const rowSelectionWeekly = {
        selectedRowKeys: selectedRowKeysWeekly,
        onChange: onSelectChangeWeekly,
    }

    const OpenMailModal = () => {
        if (selectedRowKeysWeekly.length > 0 || selectedRowKeysBiWeekly.length > 0) {
            setMailpopup(true)
        }
        else {
            WarnMessage("Please select records to sent mail.")
        }
    }

    const CloseMailModal = () => {
        setError('')
        setFromAdd('')
        setFromName('')
        setCCAdd([])
        setToAdd([])
        setSubject('')
        setBody('')
        setMailpopup(false)
    }

    const emailValidationRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    const handleInputChange = (setterFunction, fieldName) => (e) => {
        const value = e.target.value
        setterFunction(value);
        if (value === '') {
            setError(`${fieldName} cannot be empty.`)
        } else {
            if (error && error.includes(fieldName)) {
                setError('')
            }
        }
    }

    const validateEmailField = (value, fieldName) => {
        if (value === '') {
            setError(`${fieldName} cannot be empty.`)
        } else if (!emailValidationRegex.test(value)) {
            setError(`Please enter a valid email address for ${fieldName}.`)
        }
    }
    return (
        <>
            <Layout style={{ backgroundColor: "white", height: "100vh", display: "flex", overflow: "hidden" }} >
                <SideNavBar />
                <Layout style={{ backgroundColor: "white", overflow: "hidden" }}>
                    <Header className="preview-header-class"><Navbar /></Header>
                    <Content className="preview-content">
                        <div className="reporting-title">Non Exempt employees with more than 40Reg hours</div>
                        <div className="statutory-table-div">
                            <Tabs defaultActiveKey="1" >
                                <TabPane tab="Weekly" key="1">
                                    {
                                        tableLoader ? <Spin tip="Loading...">
                                            <Form form={form} component={false}>
                                                <Table className="statutory-table" rowClassName="editable-row"
                                                    bordered
                                                    scroll={{ x: "max-content", y: 350 }}
                                                    columns={Weecolumns}
                                                    dataSource={StatutoryWeedata.map(item => ({ ...item, key: item.FileNumber }))}
                                                    rowSelection={rowSelectionWeekly}
                                              
                                                />
                                            </Form>
                                        </Spin> : StatutoryWeedata ?
                                            <Form form={form} component={false}>
                                                <Table className="statutory-table" rowClassName="editable-row"
                                                    columns={Weecolumns}
                                                    bordered
                                                    dataSource={StatutoryWeedata.map(item => ({ ...item, key: item.FileNumber }))}
                                                    scroll={{ x: "max-content", y: 350 }}
                                                    rowSelection={rowSelectionWeekly}
                                                
                                                />
                                            </Form>
                                            : null
                                    }
                                </TabPane>
                                <TabPane tab="Bi-Weekly" key="2">
                                    {
                                        tableLoader ? <Spin tip="Loading...">
                                            <Form form={form} component={false}>
                                                <Table className="statutory-table" rowClassName="editable-row"
                                                    bordered
                                                    scroll={{ x: "max-content", y: 350 }}
                                                    columns={columns}
                                                    dataSource={Statutorydata.map(item => ({ ...item, key: item.FileNumber }))}
                                                    rowSelection={rowSelectionBiWeekly}
                                                // pagination={false}
                                                />
                                            </Form>
                                        </Spin> : Statutorydata ?
                                            <Form form={form} component={false}>
                                                <Table className="statutory-table" rowClassName="editable-row"
                                                    columns={columns}
                                                    bordered
                                                    dataSource={Statutorydata.map(item => ({ ...item, key: item.FileNumber }))}
                                                    scroll={{ x: "max-content", y: 350 }}
                                                    rowSelection={rowSelectionBiWeekly}
                                                // pagination={false}
                                                />
                                            </Form>
                                            : null
                                    }
                                </TabPane>
                            </Tabs>
                        </div>
                        <div style={{ width: "95%", display: "flex", justifyContent: "flex-end" }}>
                            <Button type="submit" className="statutory-validate-button" onClick={OpenMailModal}>
                                Send In Mail<SendOutlined style={{ transform: "rotate(310deg)" }} /></Button>
                        </div>
                        <Modal
                            open={Mailpopup}
                            footer={[
                                <Button
                                    className="statutory-validate-button"
                                    key="submit"
                                    type="primary"
                                    loading={loaderMail}
                                    onClick={() => SendEmail()}
                                >
                                    Send<SendOutlined />
                                </Button>,
                            ]}
                            onCancel={CloseMailModal}
                            width={600}
                            style={{ maxHeight: '500px' }}
                        >
                            <div style={{ marginTop: "5%" }}>
                                <div className="fields-div">
                                    <label className="labels-styling">From:</label>
                                    <Input size="small" className="input-styling" onChange={handleInputChange(setFromAdd, 'From Address')} onBlur={() => validateEmailField(fromAdd, 'From Address')} value={fromAdd} />
                                </div>
                                <div className="fields-div">
                                    <label className="labels-styling">From Name:</label>
                                    <Input size="small" style={{ marginLeft: "0" }} className="input-styling" onChange={handleInputChange(setFromName, 'From Name')} value={fromName} />
                                </div>
                                <div className="fields-div">
                                    <label className="labels-styling">To:</label>
                                    <Input size="small" className="input-styling" onChange={handleInputChange(setToAdd, 'To Address')} onBlur={() => validateEmailField(toAdd, 'To Address')} value={toAdd} />
                                </div>
                                <div className="fields-div">
                                    <label className="labels-styling">CC:</label>
                                    <Input size="small" className="input-styling" onChange={handleInputChange(setCCAdd, 'CC Address')} onBlur={() => validateEmailField(ccAdd, 'CC Address')} value={ccAdd} />
                                </div>
                                <div className="fields-div">
                                    <label className="labels-styling">Subject</label>
                                    <Input size="small" className="input-styling" onChange={handleInputChange(setSubject, 'Subject')} value={subject} />
                                </div>
                                <div className="fields-div">
                                    <label className="labels-styling">Body:</label>
                                    <TextArea
                                        id="textbox"
                                        autoSize={{
                                            minRows: 5,
                                            maxRows: 10,
                                        }}
                                        style={{ marginLeft: "10px", width: "80%" }}
                                        onChange={handleInputChange(setBody, 'Body')}
                                        value={body}
                                    />
                                </div>
                                <div className="fields-div">
                                    {error && <p style={{ color: 'red', marginLeft: "40px" }}>{error}</p>}
                                </div>
                            </div>
                        </Modal>
                    </Content>
                </Layout>
            </Layout>
        </>
    )
}
export default ReportingTable;